export function hasSyncedToTenant(
  targetTenantSeqs: number[] | undefined,
  tenantSeq: number,
): boolean {
  return (
    Array.isArray(targetTenantSeqs) && targetTenantSeqs.includes(tenantSeq)
  );
}
